
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.01 16.146l-8.488 8.488a4.001 4.001 0 01-5.654-.002 3.998 3.998 0 01.005-5.662L19.532 7.311a2.496 2.496 0 013.54-.003c.975.976.976 2.558.004 3.53L11.398 22.516a.993.993 0 01-1.408-.006 1 1 0 01-.001-1.413l8.486-8.486-.707-.707-8.481 8.48a1.998 1.998 0 00-.005 2.834 1.994 1.994 0 002.823.006L23.78 11.549a3.502 3.502 0 00-.002-4.948 3.499 3.499 0 00-4.951.001L7.16 18.268a5.003 5.003 0 00.001 7.07 5.003 5.003 0 007.077-.005l8.48-8.48-.708-.707z","fill":"#929292","fill-rule":"evenodd"}})])
          )
        }
      }
    